var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1060",
    d: "M9.87558 2.02807C10.2657 1.63719 10.8986 1.6369 11.2891 2.02742L13.406 4.14425C13.7965 4.53477 13.7968 5.16823 13.4066 5.55912L6.48105 12.4975C6.34559 12.6332 6.17401 12.7271 5.98674 12.7679L3.28446 13.3573C2.57367 13.5123 1.94079 12.8796 2.09477 12.168L2.68035 9.46168C2.72094 9.27408 2.81459 9.10213 2.95013 8.96634L9.87558 2.02807Z",
    stroke: "#737373",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2981",
    d: "M7.93652 4.32422L11.4676 7.85526",
    stroke: "#737373",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/pencil-outline.057ffdd609211e35dc2a5aab1b03cfe9.svg";
export { ForwardRef as ReactComponent };